import React, { useEffect, useState, useRef } from 'react'
import { observer } from "mobx-react";
import { Radio } from '@arco-design/web-react';
import './index.less'
import ChooseTemplate from '../../Components/ChooseTemplateModal'
import NoDatIcon from '@/assets/quick-img/no-data-min.png'
import {IconClose} from "@arco-design/web-react/icon";
import QuickStore from '@/stores/quickCutStore'
import { toJS } from 'mobx'
const TemplateConfig = (props) => {
  const [position, setPosition] = useState('3')
  const positionRef = useRef('3')
  const [total, setTotal] = useState(0)
  const [templateData, setTemplateData] = useState([])
  const [templateFlag, setTemplateFlag] = useState(false)
  const { settings  } = QuickStore.quickcutData
  return (
    <div className={'templateConfig'}>
      <div className={'t-header'} style={{ marginBottom: 12 }}>
        <Radio.Group
          type='button'
          name='position'
          value={position}
          onChange={(e) => {
            setPosition(e)
            positionRef.current = e
          }}
          options={[{
            label: '视频模板',
            value: '3'
          }, {
            label: '封面模板',
            value: '1'
          }]}
        ></Radio.Group>
        <span className={'total'}>
          共 { positionRef.current === '3' ? settings?.video_template.length : settings?.cover_template.length } / 100 个
        </span>
      </div>
      <div className={'scroll-box'}>
        <div className={'t-tableData'}>
          <div onClick={() => {
            setTemplateFlag(true)
          }} className={'custom-btn'}>
            <div className={'add-icon'}>+</div>
            <div className={'add-text'}>选择模板</div>
          </div>
          {
            (positionRef.current === '3' && settings?.video_template?.length > 0 && settings?.video_template || position === '1' && settings?.cover_template?.length > 0 && settings?.cover_template || []).map(((item, index) => {
              return (
                <div className={'table-item'} key={index}>
                  <img className={'img'} src={item?.cover_url} alt=""/>
                  <div onClick={() => {
                    if (positionRef.current === '3') {
                      settings.video_template.splice(index, 1)
                    } else {
                      settings.cover_template.splice(index, 1)
                    }
                  }} className="img-close-btn">
                    <IconClose className="close-btn"/>
                  </div>
                </div>
              )
            }))
          }
          {
            (positionRef.current === '3' && settings?.video_template.length === 0 || positionRef.current === '1' && settings?.cover_template.length === 0) && (
              <div className={'no-data'}>
                <img src={NoDatIcon} alt=""/>
                <span className={'info'}>暂无数据</span>
              </div>
            )
          }
        </div>
      </div>
      <ChooseTemplate submitHandle={(arr) => {
        QuickStore.videoTemplates = []
        QuickStore.coverTemplates = []
        const data = arr.map((item) => {
          const json = JSON.parse(item.content)
          if (positionRef.current === '3') {
            const custom_data = JSON.parse(item.custom_data)
            console.log(custom_data.AspectRatio, 'AspectRatio')
            if (json?.timeline) {
              json.timeline.AspectRatio = custom_data.AspectRatio
              json.timeline.From = custom_data.From
              json.timeline.FECanvas = custom_data.FECanvas
            } else {
              json.timeline = {}
            }
            return {
              id: item.id,
              cover_url: item.cover_url,
              content: JSON.stringify(json),
              cover: item.cover,
              custom_data: item.custom_data
            }
          }
          if (positionRef.current === '1') {
            return {
              id: item.id,
              cover_url: item.cover_url,
              content: JSON.stringify(json),
              cover: item.cover,
              custom_data: JSON.parse(item.custom_data).type
            }
          }
        })
        if (positionRef.current === '3') {
          settings.video_template = data
        }
        if (positionRef.current === '1') {
          settings.cover_template = data
        }
        setTemplateFlag(false)
      }} fileType={positionRef.current} handCancel={() => {
        setTemplateFlag(false)
      }} visible={templateFlag}/>
    </div>
  )
}
export default observer(TemplateConfig)
